export type ElioContext = 'offer' | 'headquarter';
